import styled from '@emotion/styled';
import { space } from 'styled-system';

/**
 * When using this component to put padding spacing in between components,
 * the padding is doubled unless specified with padding just on one side.
 * For example, <Spacer p="1"/> is actually 2.
 */
export const Spacer = styled.div(space);
